import React from "react";
import styles from "./topDonorSort.module.scss";

type TTopDonorSortItem = {
  label: string;
  value: boolean;
};

type TTopDonorSort = {
  items: TTopDonorSortItem[];
  onSelect: (value: boolean) => void;
  selected: boolean;
};

type TTopDonorSortItemBlock = {
  item: TTopDonorSortItem;
  onSelect: (value: boolean) => void;
  selected: boolean;
};

const TopDonorSort: React.FC<TTopDonorSort> = ({
  items,
  onSelect,
  selected,
}) => {
  if (!items.length) return null;
  return (
    <div className={styles.TopDonorSortContainer}>
      <div className={styles.TopDonorSort}>
        {items.map((item) => (
          <TopDonorSortItem
            item={item}
            selected={selected === item.value}
            onSelect={onSelect}
            key={item.label}
          />
        ))}
      </div>
    </div>
  );
};

const TopDonorSortItem: React.FC<TTopDonorSortItemBlock> = ({
  item,
  selected,
  onSelect,
}) => {
  const onClick = () => {
    onSelect(item.value);
  };
  return (
    <div className={styles.TopDonorSortItem} onClick={onClick}>
      <div
        className={styles.TopDonorSortItem_Container}
        data-selected={selected}
      >
        <span>{item.label}</span>
      </div>
      {selected && <div className={styles.TopDonorSortItem_Selected} />}
    </div>
  );
};

export default TopDonorSort;
